/*
 * General utils for managing cookies in Typescript.
 */
export const Cookie = {

  getCookies(): string[] {
    return (document.cookie.split("; ").map(s => {
      const kv = s.split("=");
      return kv[0];
    }) || []);
  },

  setCookie(name: string | null, val: string | null, expires: number | Date | null): void{
    if(name === null) return;
    if(val === null) return;


    const date = new Date();
    const value = val;

    if(expires === null) {
    // Set it expire in 7 days
      date.setTime(date.getTime() + (7 * 24 * 60 * 60 * 1000));
    } else if (typeof(expires) === "number") {
      date.setTime(date.getTime() + ((Math.floor(expires)) * 1000));
    } else {
      date.setDate(expires.valueOf());
    }

    // Set it
    document.cookie = name+"="+value+"; expires="+date.toUTCString()+"; path=/";
  },

  setSessionCookie(name: string | null, val: string | null): void{
    if(name === null) return;
    if(val === null) return;

    const value = val;

    // Set it
    document.cookie = name+"="+value+"; path=/";
  },

  getCookie(name: string | null): string | null {
    if(name === null) return null;

    const value = "; " + document.cookie;
    const parts = (value.split("; " + name + "=") || []);

    if (parts.length == 2) {
        return ((parts.pop() || "").split(";").shift() || null);
    }

    return null;
  },

  deleteCookie(name: string | null): void {
    if(name === null) return;

    const date = new Date();

    // Set it expire in -1 days
    date.setTime(date.getTime() + (-1 * 24 * 60 * 60 * 1000));

    // Set it
    document.cookie = name+"=; expires="+date.toUTCString()+"; path=/";
  }
}